import { SideNavigationMenu } from "@/components/shared";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const SettingsLayout = () => {
  const { t } = useTranslation();

  const navLinks = [
    { route: "billings", text: t("admin.navlinks.billings")},
    { route: "organizations", text: t("admin.navlinks.organizations")},
  ];

  return (
    <div>
      <div className="flex select-none">
        {/* Navigation Menu */}
        <SideNavigationMenu navLinks={navLinks} headerTitle={t("components:header.profile.admin")} />

        {/* Form */}
        <div className="grow h-screen overflow-y-auto">
          <Outlet/>
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout;
